//MATT:  I used the http-hook for this, and probably will do so for the
//remaining edit components.
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../../shared/components/LeagueDatabaseTable'
import Input from '../components/FormElements/Input'
//import Button from '../components/UIElements/Button'
import AdminButton from '../components/UIElements/AdminButton'
import { VALIDATOR_REQUIRE } from '../util/validators'
import './VenueForm.css'
import AdminNavigation from '../../admin/components/AdminNavigation'
import { useHttpClient } from '../hooks/http-hook'
import { useForm } from '../hooks/form-hook'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import ErrorModal from '../components/UIElements/ErrorModal'

const UpdateDropdownTournamentForm = () => {
	const { isLoading, error, sendRequest, clearError } = useHttpClient()
	const [loadedDropdownTournament, setLoadedDropdownTournament] = useState()
	const tournamentId = useParams().tournamentId
	let navigate = useNavigate()

	//only need setFormData in Update
	const [formState, inputHandler, setFormData] = useForm(
		{
			tournamentName: {
				value: '',
				isValid: false,
			},
			tournamentLink: {
				value: '',
				isValid: false,
			},
		},
		false,
	)

	//getDropdownTournamentData
	//
	useEffect(() => {
		const fetchDropdownTournament = async () => {
			try {
				const responseData = await sendRequest(
					`${process.env.REACT_APP_BACKEND_URL}/admin/dropdowns/${tournamentId}`,
				)
				setLoadedDropdownTournament(responseData.dt)
				setFormData(
					{
						tournamentName: {
							value: responseData.dt.tournamentName,
							isValid: true,
						},
						tournamentLink: {
							value: responseData.dt.tournamentLink,
							isValid: true,
						},
					},
					true,
				)
			} catch (err) {}
		}
		fetchDropdownTournament()
	}, [sendRequest, tournamentId, setFormData])

	const dtUpdateSubmitHandler = async (event) => {
		event.preventDefault()
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/updateDropdownTournament/${tournamentId}`,
				'PATCH',
				JSON.stringify({
					tournamentName: formState.inputs.tournamentName.value,
					tournamentLink: formState.inputs.tournamentLink.value,
				}),
				{
					'Content-Type': 'application/json',
				},
			)
			navigate('/admin/dropdown')
		} catch (err) {}
	}

	if (isLoading) {
		return (
			<div className='center'>
				<LoadingSpinner />
			</div>
		)
	}

	if (!loadedDropdownTournament) {
		return (
			<div className='center'>
				<h2>Could not find tournament!</h2>
			</div>
		)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={clearError} />
			{!isLoading && loadedDropdownTournament && (
				<div>
					<AdminNavigation />
					<main>
						<h2>Edit Venue</h2>
						<form className='venue-form' onSubmit={dtUpdateSubmitHandler}>
							<Input
								id='tournamentName'
								element='input'
								type='text'
								label='Enter Tournament Name'
								validators={[VALIDATOR_REQUIRE()]}
								errorText='Please enter a valid name'
								onInput={inputHandler}
								initialValue={loadedDropdownTournament.tournamentName}
								initialValid={true}
							/>
							<Input
								id='tournamentLink'
								element='input'
								type='text'
								label='Link'
								validators={[VALIDATOR_REQUIRE()]}
								errorText='Please enter a valid link'
								onInput={inputHandler}
								initialValue={loadedDropdownTournament.tournamentLink}
								initialValid={true}
							/>
							<AdminButton type='submit' disabled={!formState.isValid}>
								{/* UPDATE VENUE */}
								Save Changes
							</AdminButton>
						</form>
					</main>
				</div>
			)}
		</React.Fragment>
	)
}

export default UpdateDropdownTournamentForm
